module.exports = __webpack_public_path__ + "static/media/join-healthcare.9198f825.svg";